module.exports = __webpack_public_path__ + "img/__icon_BUS_SKRZYNIA.624780ef.svg";